export const HER_FOOTER_ACTIONS = {
    FETCH_DATA: "FETCH_FOOTER_DATA"
};
